<template>
    <main class="justify-center justify-items-center text-center text-black">
      <section class="grid">
        <!-- KYC Animation -->
        <div class="w-auto h-36">
          <Vue3Lottie :animationData="CreditOfferBankAnimation" :speed="1" :loop="true" />
        </div>
        <div class="grid gap-1">
          <p class="label-text-myriad px-10">
            You got an exciting Credit Offer!
          </p>
          <p class="text-header capitalize font-bold text-primary font-blogger">
            {{ $filters.formatMoney(creditOfferData?.amountApproved || 0) }}
          </p>
        </div>
      </section>
      <section class="grid pt-4">
        <div class="shadow-cardShadow w-full rounded-2xl bg-white">
          <section class="flex gap-2 items-center px-4 py-4 shadow-cardShadow">
            <div class="w-8 h-8">
              <img src="../assets/applicationEpaylater.svg" class="h-8 w-8" alt="logo"/>
            </div>
            <div class="grid text-left">
              <!-- <p class="label-text-medium capitalize"> {{ creditOfferData?.nbfc }} </p> -->
              <p class="label-text-medium capitalize">
                Application ID: {{ applicationId }}
              </p>
            </div>
          </section>
          <section class="flex gap-2 items-start px-4 pt-4">
            <div class="w-10 h-10 pt-2">
              <img src="../assets/credit-offer-money.png" class="h-8 w-8" alt="logo"/>
            </div>
            <div class="grid text-left">
              <p class="label-text-medium"> Daily/Weekly Installment Loans </p>
              <div class="grid text-left">
                <ul class="list-disc px-5 py-2 tracking-wide secondary-headingColor-text">
                  <li>Get money directly in your bank account.</li>
                  <li>Repay in small daily or weekly amounts that match your sales.</li>
                </ul>
              </div>
            </div>
          </section>
          <!-- <section class="flex gap-2 items-center p-4">
            <div class="w-8 h-8">
              <img src="../assets/credit-offer-calender.png" class="h-8 w-8" alt="logo"/>
            </div>
            <div class="grid text-left">
              <p class="label-text-medium capitalize">1.4% Late Fee</p>
              <p class="secondary-heading-text">
                Charged in case of late payment
              </p>
            </div>
          </section> -->
          <section class="flex gap-2 items-start px-4 pt-2 pb-4">
            <div class="w-8 h-8">
              <img src="../assets/epl-icon.png" class="h-8 w-8" alt="logo"/>
            </div>
            <div class="grid text-left">
              <p class="label-text-medium capitalize">Buy Now Pay Later </p>
              <div class="grid text-left">
                <ul class="list-disc px-4 py-2 tracking-wide secondary-headingColor-text">
                  <li>Buy goods for your business today, pay later.</li>
                  <li>0% interest up to 14 days at select merchants.</li>
                  <li>Shop now, pay later with low interest and easy repayment.</li>
                </ul>
              </div>
            </div>
          </section>
          <section class="flex gap-2 items-center p-4 bg-creditOfferBannerColor rounded-b-2xl">
            <div class="grid text-left">
              <ul class="list-disc px-4 py-2 tracking-wide secondary-headingColor-text">
                <li>Every 2 years, just renew to continue your loan offer.</li>
                <li>Your credit offer amount may change based on the information provided.</li>
              </ul>
            </div>
          </section>
        </div>
      </section>
      <span class="grid pb-10"></span>
      <section class="footer">
        <custom-button
          arrowAnimation
          variant="primary"
          @click="getApprovalKYC"
        >
          <p class="grid text-base">
            Verify & Continue
          </p>
        </custom-button>
      </section>
    </main>
  </template>
  <script>
  import { mapGetters } from 'vuex';
  import CustomButton from '../components/CustomButton.vue';
  import CreditOfferBankAnimation from '../assets/animation/Credit-Offer-Bank-Animation.json';

  export default {
    name: 'Credit Offer Selection',
    components: {
      CustomButton,
    },
    computed: {
      ...mapGetters(['applicationId', 'flagsData']),
    },
    data() {
      return {
        loading: undefined,
        CreditOfferBankAnimation,
        creditOfferData: JSON.parse(localStorage.getItem('creditOfferData'))
      };
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_INITIAL_CREDIT_OFFER_LANDED, {
          [this.$mixpanelPayload.CREDIT_LIMIT]: this.creditOfferData?.amountApproved || 0
        });
        // if (this.creditOfferData.amountApproved === 0) {
        //   this.$router.push({
        //     name: "Application Rejected",
        //   });
        // }
      },
      getApprovalKYC() {
        this.$trackEvent(this.$mixpanelEvent.G_PAY_MICRO_APP_OFFER_AGREED);
        if (!this.flagsData?.isKycEnabled) {
          this.$router.push({
            name: 'Current Address',
            query: {
              isKycEnabled: true,
            }
          });
        } else {
          this.$router.push({ name: 'Pre Approval KYC Selection' });
        }
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .dot {
    height: 6px;
    width: 6px;
    background-color: black;
    border-radius: 50%;
    display: inline-block;
  }
  </style>
